export const WebViewActions = {
  CLOSE_WEBVIEW: 'close_webview',
  LOGIN: 'login',
  OPEN_WEBVIEW: 'open_webview',
  UPDATE_APP_BAR: 'update_appbar',
  NATIVE_SHARE: 'native_share',
  OPEN_CAMERA: 'open_native_camera',
  OPEN_SETTINGS_PAGE: 'open_settings_page',
  CHECK_PUSH_NOTIFICATION_PERMISSION: 'check_notification_enabled',
}
interface IGenericWebviewParams {
  action: string
  actionValue?: Record<string, any>
}

export const genericWebviewHandler = async ({ action, actionValue }: IGenericWebviewParams) => {
  const stringWebViewData = JSON.stringify({
    action: action,
    action_value: actionValue || {},
  })
  //   @ts-expect-error
  if (window?.flutter_inappwebview?.callHandler) {
    //   @ts-expect-error
    return window.flutter_inappwebview.callHandler('WebViewConnect', stringWebViewData)
  }
}
